import ShootPrepartionGuidelines from '../../components/ShootPreparationGuidelines';

const ShootPreparation = () => {
    return (
        <>
            <ShootPrepartionGuidelines />
        </>
    );
};

export default ShootPreparation;
